import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import { Link } from "react-router-dom";

export default class Viewcoupons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          { label: "Banner Name", field: "banner_name", sort: "asc", width: 150 },
          { label: "Entity Name", field: "entity_name", sort: "asc", width: 150 },
          { label: "Module",field: "module_type",sort: "asc",width: 150,},
          { label: "Position", field: "position", sort: "asc", width: 120 },
          { label: "Start Date", field: "start_date", sort: "asc", width: 150 },
          { label: "End Date", field: "end_date", sort: "asc", width: 150 },
          { label: "Redirection Tags", field: "redirection_tags", sort: "asc", width: 120 },
          { label: "Images", field: "images", sort: "asc", width: 120 },
          { label: "Status", field: "status", sort: "asc", width: 100 },
          { label: "Actions", field: "actions", sort: "asc", width: 100 }
        ],
        rows: [],
      },
      loading: true // Add loading state
    };
    this.deleteBanner = this.deleteBanner.bind(this);
  }
  // To get detais after first render
  componentDidMount = () => {
    this.fetchBannersData();
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //update status for patient
  updateBannerStatus = (bannerId, currentStatus) => {
    // Toggle status: active (1) <-> inactive (0)
    const newStatus = currentStatus === "active" ? 0 : 1;
    const payload = { status: newStatus };
    Httpconfig.httptokenput(`${Constant.siteurl}api/OM/Banners/${bannerId}`, payload)
      .then((response) => {
        toast.success("Banner status updated");
        this.fetchBannersData(this.state.retailerId);
      })
      .catch((error) => {
        toast.error("Failed to update status");
      });
  };

  fetchBannersData(entity_id) {
    this.setState({ loading: true }); // Set loading true before API call
    const payload = {
      module_type: "",
      status: '',
      search: "",
      page: 1,
      limit: 10,
      entity_id: entity_id
    };
    Httpconfig.httptokenpost(Constant.siteurl + "api/OM/Banners/list", payload)
      .then((response) => {
        const banners = response.data.data || [];
        let assignvalues = banners.map((item, key) => ({
          
          banner_name: item.banner_name,
          module_type: item.module_type,
          position: item.position,
          start_date: item.start_date,
          end_date: item.end_date,
          redirection_tags: item.redirection_tags,
          entity_name:item.retailer && item.retailer.storename ? item.retailer.storename : "---", 
          status: (
            <MDBBadge
              color={item.status === "active" ? "success" : "warning"}
              style={{ cursor: "pointer" }}
              onClick={() => this.updateBannerStatus(item.banner_id, item.status)}
              title={`Click to ${item.status === "active" ? "deactivate" : "activate"} this banner`}
            >
              {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
            </MDBBadge>
          ),
          images: (
            <div style={{ display: "flex", gap: "5px" }}>
              {item.images && item.images.map((img, idx) => (
                <img
                  key={img.image_id}
                  src={img.image_url}
                  alt={img.alt_text || `Banner ${idx + 1}`}
                  style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4, border: "1px solid #ccc" }}
                />
              ))}
            </div>
          ),
          actions: (
            <div>
              <span>
                <Link
                  to={`/admin/AdminUpdateBanners/${item.banner_id}`}
                  className="fa fa-edit point-cursor"
                  title={`Update ${item.banner_name}`}
                ></Link>
              </span>
              &nbsp;
              <span>
                <i
                  onClick={() => this.deleteBanner(item.banner_id, item.banner_name)}
                  className="fa fa-trash point-cursor"
                  title={`Delete ${item.banner_name}`}
                  style={{ color: "red", cursor: "pointer" }}
                ></i>
              </span>
            </div>
          )
        }));
        let datatable = { ...this.state.datatable };
        datatable.rows = assignvalues;
        this.setState({ datatable, loading: false }); // Set loading false after data
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  //delete controller
  deleteBanner(bannerId, bannerName) {
    const isConfirm = window.confirm(`Are you sure to delete ${bannerName}?`);
    if (isConfirm) {
      Httpconfig.httptokendelete(`${Constant.siteurl}api/OM/Banners/${bannerId}`)
        .then((response) => {
          toast.success("Successfully Deleted Banner");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => { });
    }
  }
  render() {
    const { datatable, loading } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
<div className="tab-header create-coupon-header">
  <h3> Create  Banner </h3>
  <Link
    to="/admin/AdminUpdateBanners"
    className="btn  btn-primary fright"
  >
    Create Banner
  </Link>
</div>

              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3> Banners</h3>
                      </div>
                      <div id="reg_form" class="viewcoupons">
                        {loading ? (
                          <p>Loading............</p>
                        ) : datatable.rows.length === 0 ? (
                          <p>No banners found</p>
                        ) : (
                          <MDBDataTable
                            responsive
                            striped
                            bordered
                            small
                            data={datatable}
                          />
                        )}

                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="update_btn"
                              style={{ textAlign: "right" }}
                            ></div>
                          </div>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}